import { renderRoutes } from 'react-router-config';
import { IProps } from './model';

export const TemplateEmpty = (props: IProps) =>
  renderRoutes(props.route?.routes);
